'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSkipArrow, iconSkipArrowTag } from '@ni/nimble-components/dist/esm/icons/skip-arrow';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSkipArrow };
export { iconSkipArrowTag };
export const NimbleIconSkipArrow = wrap(IconSkipArrow);